import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { styled, SxProps, Theme } from "@mui/material/styles";

declare global {
  interface Window {
    adsbygoogle: Array<unknown> & {
      push: (config?: Record<string, unknown>) => void;
    };
  }
}

interface GoogleAdProps {
  slot: string;
  format?: string;
  responsive?: boolean;
  sx?: SxProps<Theme>;
}

interface GoogleAdState {
  currentSlot: string;
}

const AdContainer = styled(Box)({
  display: "block",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  textAlign: "center",
});

const GOOGLE_AD_CLIENT_ID = process.env.REACT_APP_GOOGLE_AD_CLIENT as string | undefined;
const IS_PROD = process.env.REACT_APP_ENV === "production";

const GoogleAd: React.FC<GoogleAdProps> = ({
  slot,
  format = "auto",
  responsive = true,
  sx,
}) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error("Adsbygoogle push error:", err);
    }
  }, [slot]);

  if (!GOOGLE_AD_CLIENT_ID) {
    console.warn("Google Ad Client ID not configured");
    return null;
  }

  return (
    <AdContainer sx={sx}>
      <ins
        key={slot}
        className="adsbygoogle"
        data-ad-client={GOOGLE_AD_CLIENT_ID}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
        data-adtest={IS_PROD ? undefined : "on"}
        style={{ display: "block" }}
      />
    </AdContainer>
  );
};

export default GoogleAd;
